export default __webpack_public_path__ + "static/2-5ee6eeeae61daae742c5b342b982ced3.jpeg";